import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const StorefrontPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./StorefrontPage')).StorefrontPage,
  }))
);
